"use client";

import { ArrowLeft2, ArrowRight2 } from "iconsax-reactjs";
import { useLocale } from "next-intl";
import { getDirection, type Locale } from "@/lib/i18n";

interface DirectionalChevronProps {
  /** "forward" = direction of travel (right in LTR, left in RTL); "back" = the inverse. */
  direction?: "forward" | "back";
  size?: number;
  className?: string;
  "aria-label"?: string;
}

/**
 * Locale-direction-aware chevron. Use for navigational affordances (view-details,
 * read-more, view-all, drill-in, back). Do NOT use for controls that manage their
 * own direction (calendar, carousel, stepper, star-rating).
 */
export const DirectionalChevron = ({
  direction = "forward",
  size = 16,
  className,
  "aria-label": ariaLabel,
}: DirectionalChevronProps) => {
  const dir = getDirection(useLocale() as Locale);
  const pointsRight =
    (direction === "forward" && dir === "ltr") ||
    (direction === "back" && dir === "rtl");
  const Icon = pointsRight ? ArrowRight2 : ArrowLeft2;
  return <Icon size={size} className={className} aria-label={ariaLabel} />;
};
